// 確認ダイアログ（ConfirmModal 島）を JS から命令的に開くためのブリッジ。
//
// 旧 `Confirm.confirm({...})`（jquery-modal 版）の置き換え。ConfirmModal 島が
// `COORUM_CONFIRM_EVENT` を購読しているので、任意の JS からこの関数を呼べば同じ島を開ける。
// acceptCallback / onClose は関数参照だが、同一プロセス内の CustomEvent.detail なのでそのまま渡せる。
//
// 宣言的な `<a data-coorum-confirm=...>` は島側が capture で直接拾うため、この関数は使わない。

export const COORUM_CONFIRM_EVENT = 'coorum:confirm';

export type CoorumConfirmOptions = {
  /** 本文（改行は保持される） */
  message: string;
  /** ヘッダタイトル（省略時はタイトル無し） */
  title?: string;
  /** 実行ボタンのラベル（既定 OK） */
  accept?: string;
  /** キャンセルボタンのラベル（既定 キャンセル） */
  reject?: string;
  /** 実行ボタンの遷移先。指定時は <a href> として描画し、data-method/remote と併せ @rails/ujs に委ねる */
  href?: string;
  /** @rails/ujs 用の HTTP メソッド（delete 等） */
  method?: string;
  /** @rails/ujs の remote（true で XHR 送信） */
  remote?: boolean;
  /**
   * 実行時に呼ぶコールバック（href 遷移でなく JS 側で遷移する場合。form.submit / history.back 等）。
   * 旧 Confirm.js と同じく OK ではモーダルを閉じない（遷移によるページ破棄に任せる）ため、
   * ページ遷移で終わらない処理を渡すとモーダルが開いたままになる点に注意。
   */
  acceptCallback?: () => void;
  /** 実行以外（キャンセル / ✕ / Escape / 背景クリック）で閉じた時に呼ぶコールバック */
  onClose?: () => void;
};

/** ConfirmModal 島に確認ダイアログの表示を依頼する。 */
export function coorumConfirm(options: CoorumConfirmOptions): void {
  document.dispatchEvent(
    new CustomEvent<CoorumConfirmOptions>(COORUM_CONFIRM_EVENT, { detail: options }),
  );
}
